import { match } from 'ts-pattern';
import {
  ALL_SOCIAL_PLATFORMS,
  ALL_SOCIAL_PLATFORM_TYPE,
  FEATURE_FLAGS,
} from '~/constants';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { ConnectedPlatformsType } from '~/screens/ManagePlatforms';

const allPlatforms: ALL_SOCIAL_PLATFORM_TYPE[] = [
  ALL_SOCIAL_PLATFORMS.instagram,
  ALL_SOCIAL_PLATFORMS.tiktok,
  ALL_SOCIAL_PLATFORMS.snapchat,
  ALL_SOCIAL_PLATFORMS.youtube,
];

export const useGetAvailablePlatforms = (
  connectedPlatforms?: ConnectedPlatformsType[],
): ALL_SOCIAL_PLATFORM_TYPE[] => {
  // If we have connectedPlatforms then we assign it to platforms. Otherwise it's an empty array.
  const platforms = connectedPlatforms?.map((cp) => cp.platform) ?? [];

  const offPlatformYoutube =
    useFeatureFlag(FEATURE_FLAGS.foamOffPlatformYoutube) === 'enabled';

  return allPlatforms.filter((platform) => {
    const isPlatformAvailable = !platforms.includes(platform);
    if (!isPlatformAvailable) return false; // Skip if platform is already connected

    const isYoutube = platform === ALL_SOCIAL_PLATFORMS.youtube;

    if (!isYoutube) return true;

    // Here the platform can either be youtube or snapchat
    const isFlagEnabled = match(platform)
      .with(ALL_SOCIAL_PLATFORMS.youtube, () => offPlatformYoutube)
      // Never comes here
      .otherwise(() => '');

    return isFlagEnabled;
  });
};
